module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAAAXNSR0IArs4c6QAAASdJREFUOBFjYCASmJiYlIIwkcoZmIlRaGpqmvj///8pQLWuMjIyj549e3aBkD5GQgqArvQDqlkHNBjsCEZGxr9AftCZM2c24dOL12CgS+2ABu4EYg5kQ4CG/wBi99OnTx9CFkdm4zTYzMxM/+/fvweBivmRNSCxPzIzM9ufOnXqIpIYnInVYKBLlYCuPArEEnCVWBhAV78AYmugy++hS2MYDDRUAmqoErpibHygwfeghr9Alkcx2NjYGORtkPf1kRURwQYFh/3Zs2c/wtQywRgODg4cQJtBMU2qoSAj9EF6QWbAzAMbHBoayvzly5eVwCCwg0mQSoP0gswAmQXSCyY4OTnnAdnhpBqGRb36+/fv5Z4/f76REZgBuoC2EZ1VsRiGIQQMlm4AS4hnTP80ocMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/gb.png
// module id = 668
// module chunks = 0